export default {
  btnAdd:'Add category',
  btnEdit:'Edit',
  placeholderTitle:'Enter name',
  back : 'back',
  save : 'save'
}
